import { render } from "./ProductReviewModal.vue?vue&type=template&id=4ee848a9&ts=true"
import script from "./ProductReviewModal.vue?vue&type=script&lang=ts"
export * from "./ProductReviewModal.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/flowerdiy/flowerdiy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__